export enum TripRequestLogsSort {
    TIMESTAMP_ASC = 'timestamp',
    LAST_TIMESTAMP_ASC = 'lastTimestamp',
    STATUS_ASC = 'status',
    TRIP_DEFINITION_NAME_ASC = 'tripDefinitionName',
    TRIP_CODE_ASC = 'tripCode',
    USER_NAME_ASC = 'userName',
    REQUESTS_COUNT_ASC = 'requestsCount',
    CREATED_AT_ASC = 'createdAt',
    TIMESTAMP_DESC = '-timestamp',
    LAST_TIMESTAMP_DESC = '-lastTimestamp',
    STATUS_DESC = '-status',
    TRIP_DEFINITION_NAME_DESC = '-tripDefinitionName',
    TRIP_CODE_DESC = '-tripCode',
    USER_NAME_DESC = '-userName',
    REQUESTS_COUNT_DESC = '-requestsCount',
    CREATED_AT_DESC = '-createdAt',
}
